class ChangeStudentPasswordController {
    // @ngInject
    constructor(targetUser, $stateParams) {
        this.targetUser = targetUser;
        this.$stateParams = $stateParams;
    }
}

export default ChangeStudentPasswordController;
